import React from "react";
import { Counter } from "../shared.jsx";

// Wspólny komponent prezentacyjny paska KPI.
// Używany przez HomePage.jsx (animate=true → animowany Counter) ORAZ przez podgląd Puck
// (animate=false → liczba statyczna, żeby edycja wartości była widoczna NATYCHMIAST;
// Counter animuje tylko raz i nie reaguje na późniejszą zmianę `to`).
// reveal: jak w HomeHero — klasa .rv tylko na stronie, w edytorze false.
export function HomeKpiStrip({ kpis = [], reveal = true, animate = true }) {
  return (
    <section className="kpi-section">
      <div className="kpi-strip">
        {kpis.map((kpi, i) => (
          <div key={i} className={reveal ? "kpi-cell rv" : "kpi-cell"}>
            <span className="num">
              <span className="arr-up">↑</span>
              {animate
                ? <Counter to={kpi.value} suffix={kpi.suffix} duration={kpi.duration} />
                : <>{kpi.value}{kpi.suffix}</>}
            </span>
            <span className="lbl">{kpi.label}</span>
            <span className="tag">{kpi.tag}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
